/** CRM management routes **/
import Layout from '@/layout';

const crmRoutes = {
  path: '/crm',
  component: Layout,
  redirect: '/crm/requests',
  name: 'CRM',
  alwaysShow: true,
  meta: {
    title: 'CRM',
    icon: 'el-icon-s-platform',
    permissions: ['manage user'],
  },
  children: [
    {
      path: 'requests',
      component: () => import('@/views/crm/CrmRequests'),
      name: 'CrmRequests',
      meta: {
        title: 'Prośby o dostęp',
        icon: 'el-icon-user',
        noCache: true,
        permissions: ['manage user'],
      },
    },
  ],
};

export default crmRoutes;
